"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDesignAllowedForPageCount;
const constants_1 = require("./constants");
const newrelic_1 = require("../split.io/newrelic");
function isDesignAllowedForPageCount(design, printableCount) {
  var _a;
  if (design.allowedPageCounts === constants_1.ALL) {
    return true;
  }
  // "15...15"
  const range = ((_a = design.allowedPageCounts) === null || _a === void 0 ? void 0 : _a.split('...').map(parseFloat)) || [];
  if (!range.length) {
    if ((0, newrelic_1.canNR)()) {
      window.newrelic.addPageAction(`isDesignAllowedForPageCount: Invalid allowedPageCounts (${design.allowedPageCounts}) in design ${design.designId}`);
    }
    return false;
  }
  return printableCount >= range[0] && printableCount <= range[1];
}